<template>
    <div class="main mt15">
        <div class="banner" @click="toBuy">
            <img src="../../../images/guaranteeTab.jpg" alt="" ref="info">
            <div class="banner-container">
            </div>
        </div>
        <div class="tabs" ref="tabs">
            <div class="tabs-container" :class="{fixed:fixed}">
                <Tabs :value="tabName" @on-click="tabChange">
                    <TabPane label="产品特色" name="info"></TabPane>
                    <TabPane label="保障方案" name="case"></TabPane>
                    <TabPane label="常见问题" name="question"></TabPane>
                    <TabPane label="理赔流程" name="claim"></TabPane>
                </Tabs>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">产品特色</div>
            <div class="detail-main">
                <div style="color: red;">咨询电话：187 6642 6120</div>
                <div class="detail-main-text" ref="case">
                    建工施工合同履约保证保险是由保险公司应投保人（承包方/施工方）的要求，向被保险人（发包方/业主）提供的，保证被保险人履行工程建设合同责任和义务的保险。<br />
                    保障的是投保人出现与《建设工程施工合同》规定的各项违约行为（质量不合格、延误工期等)，给被保险人造成的直接经济损失，保险人负责赔偿。
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">保障方案</div>
            <div class="detail-main">
                <div class="center">
                    <table class="productDetail-table">
                        <thead>
                            <tr>
                                <th>项目</th>
                                <th>内容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hoverTr">
                                <td>投保人</td>
                                <td>建筑施工企业（中标人、承包人）</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>被保险人</td>
                                <td>工程发包方、业主方（招标人）；即保函接收人</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>项目信息</td>
                                <td>项目名称：按照合同中的项目名称为准<br />工程造价：按照合同中的合同总价为准
                                </td>
                            </tr>
                            <tr class="hoverTr">
                                <td>优势</td>
                                <td>有效替代履约保证金，极大释放企业资金</td>
                            </tr>
                            <tr class="hoverTr" ref="question">
                                <td>保险金额</td>
                                <td>合同要求缴纳的履约保证金金额</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保费</td>
                                <td>保险金额*保险费率（保险费率千4-百1）</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">常见问题</div>
            <div class="detail-main">
                <div class="detail-main-text">
                    <p><b>1、企业为什么要买履约保证保险？</b></p>
                    <p>
                        答：建企承揽项目需提交“履约保证金”，而履约保证保险是国家政策明文支持的创新履约保证金代替形式，具有费用成本低、手续资料少、办理方便快捷等特点。
                    </p>
                    <p><b>2、为何选择我们投保？</b></p>
                    <p>答：成本优势：费率可低至千4，盘活企业保证金99.6%<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    办理优势：办理便捷，不占授信，当天投保当天出单。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    服务优势：全流程管家服务，链接保险机构，协助快速出单。
                    </p>
                    <p><b>3、如何投保？</b></p>
                    <p >答：提供营业执照，施工合同，上一年度财务报表，企业资质证明后获取精准保险方案，并由服务人员协助完成投保。</p>
                    <p><b>4、能举例说明下履约保证保险的优势吗？</b></p>
                    <p>举例：某道路施工项目，业主方要求承包方缴纳500万的履约保证金，由于现金担保资金占有量较大，传统保函申请门槛较高、手续办理繁琐，承包方希望投保一份履约保证金。</p>
                    <p ref="claim">
                        据此为其制定投保方案：<br />
                        ● 保额即赔偿限额500万元<br />
                        ● 保险费率千4<br />
                        ● 保费合计2万元<br />
                        ● 盘活企业应缴现金履约保证金多达498万元
                    </p>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">理赔流程</div>
            <Steps class="mt30 step-con">
                <Step 
                    title="拨打报案电话" 
                    status="process"
                    content="请立即拨打报案电话18766426120进行报案，详细说明出险情况。被保险人应在48小时内及时报案。"
                ></Step>
                <Step 
                    title="提交索赔材料" 
                    status="process"
                    content="报案后我们会告知您所需的材料，请按照要求待治疗结束后提供资料。"
                ></Step>
                <Step 
                    title="领取赔款" 
                    status="process"
                    content="资料收到后，保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款。"
                ></Step>
            </Steps>
        </div>
        
        <div class="detail allDet detail-main-text">
             <p>
                <b>请添加以下微信进行询价</b>
             </p>
            <img src="../../../images/code.png"  style="width: 20%;margin-top: 15px;" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                rules: {
                    code: [{ required: true, message: '请输入88码', trigger: 'blur' }]
                },
                tabName: 'info',
                fixed: false,
                renewId: this.$route.query.renewId || '' //续保，上一保单id
            }
        },
        mounted () {
            this.$nextTick(() => {
                window.addEventListener("scroll", this.handleScroll);
            })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            // 立即购买
            toBuy () {
                let url = '/haierProduct.html#/customized-employer-liability/fillin';
                if (this.renewId) url += `/${this.renewId}?renew=1&productCode=QYTTGZZRXPCNEW`
                else url += `?productCode=QYTTGZZRXPCNEW`
                location.href = url
            },
            // tab切换
            tabChange (val) {
                this.$refs[val].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"
                })
            },
            // 定位到伤残费率表位置
            toSC () {
                this.$refs['SC'].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                })
            },
            // 监听滚动
            handleScroll () {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > this.$refs.tabs.offsetTop) {
                    this.fixed = true;
                } else {
                    this.fixed = false;
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/productList/guarantee.vue